var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.298584,
    y: 0.46521,
    width: 63.8084,
    height: 63.8084,
    rx: 6.96092,
    fill: "#175CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5837 25.9297C17.6207 25.4765 17.6207 24.0603 18.5837 23.6071L31.7827 17.659C31.9527 17.5457 32.1793 17.5457 32.4059 17.5457C32.5758 17.5457 32.8024 17.5457 32.9723 17.659L46.1714 23.6071C47.1344 24.0603 47.1344 25.4765 46.1714 25.9297L32.9723 31.8777C32.5758 32.0476 32.1793 32.0476 31.7827 31.8777L18.5837 25.9297ZM46.1714 30.9147C47.1344 31.3112 47.1344 32.7274 46.1714 33.1806L32.9723 39.1287C32.5758 39.2986 32.1793 39.2986 31.7827 39.1287L18.5837 33.1806C17.6207 32.7274 17.6207 31.3112 18.5837 30.9147L21.8693 29.3852L31.0463 33.5771C31.4428 33.7471 31.896 33.8604 32.4059 33.8604C32.8591 33.8604 33.3122 33.7471 33.7088 33.5771L42.8858 29.3852L46.1714 30.9147ZM46.1714 38.1656C47.1344 38.5622 47.1344 39.9784 46.1714 40.4316L32.9723 46.3796C32.5758 46.5496 32.1793 46.5496 31.7827 46.3796L18.5837 40.4316C17.6207 39.9784 17.6207 38.5622 18.5837 38.1656L21.8693 36.6361L31.0463 40.8281C31.4428 40.998 31.896 41.1113 32.4059 41.1113C32.8591 41.1113 33.3122 40.998 33.7088 40.8281L42.8858 36.6361L46.1714 38.1656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon1);
export default __webpack_public_path__ + "static/media/Home_icon1.65982dc1be615af7ec7a07aad583204c.svg";
export { ForwardRef as ReactComponent };